import Link from 'next/link';

export default function GenericToastContents({
  title,
  children,
  Icon,
  buttonText
}) {
  return (
    <div className="pt-2 pr-2 pb-4 pl-4">
      <div className="flex items-start">
        <div className="flex-1 pt-1 pr-9">
          <div className="mb-1 flex items-center">
            {Icon && <Icon className="mr-1" />}

            <p className="sh10">{title}</p>
          </div>
          <div className="mb-3">
            {children && <p className="body-s">{children}</p>}
          </div>

          {buttonText && (
            <Link
              className="text-parlor-green btn-s border-parlor-green hover:bg-parlor-green-80 hover:border-parlor-green-80 block border bg-transparent px-8 py-2 text-center whitespace-nowrap transition-colors duration-150 hover:text-white"
              href="/cart"
            >
              {buttonText}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
